import { motion } from "framer-motion";
import { ReactNode } from "react";

import Message from "@afa-shared/afa-components/dist/Message";
import Text from "@afa-shared/afa-components/dist/Text";
import { StandardLink } from "@components/StandardLink";

interface IFormSuccessFeedback {
  messageHeading?: string;
  messageChildren?: ReactNode;
  messageLink?: ReactNode;
  messagePreset?: string;
}

const FormSuccessFeedback = ({
  messageHeading,
  messageChildren,
  messageLink,
  messagePreset,
}: IFormSuccessFeedback) => {
  const feedbackVariants = {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
  };
  const personuppgifterPath = "/personuppgifter";
  let heading: string = "Din information har skickats";
  let text: ReactNode = null;
  let link: ReactNode = null;

  if (messagePreset) {
    switch (messagePreset) {
      case "defaultContactForm":
        heading = "Tack för ditt meddelande!";
        text = (
          <>
            <Text
              variant="paragraph"
              children={
                "Du får svar inom två vardagar. Om du har begärt en kopia av meddelandet till din e-postadress kontrollera att den inte hamnat i din skräppost."
              }
            />
            <Text
              variant="paragraph"
              children={
                "För att skydda dina personuppgifter kan vi inte gå in i detalj på ditt ärende när vi svarar dig via e-post. När vi har avslutat ärendet raderar vi alla e-postmeddelanden."
              }
            />
          </>
        );
        link = <StandardLink url={personuppgifterPath} text={"Så behandlar vi personuppgifter"} />;
        break;
      case "eServicesContactForm":
        heading = "Tack för ditt meddelande!";
        text = (
          <Text
            variant="paragraph"
            children={
              "Du får svar inom två vardagar. Om du har begärt en kopia av meddelandet till din e-postadress kontrollera att den inte hamnat i din skräppost."
            }
          />
        );
        link = <StandardLink url={personuppgifterPath} text={"Så behandlar vi personuppgifter"} />;
        break;
    }
  } else {
    if (messageHeading) heading = messageHeading;
    if (messageChildren) text = messageChildren;
    if (messageLink) link = messageLink;
  }

  return (
    <motion.div
      variants={feedbackVariants}
      initial={false}
      animate="animate"
      transition={{ delay: 0.4, duration: 0.5 }}
    >
      <Message
        heading={heading}
        headingVariant={"h2"}
        type={"success"}
        children={text}
        linkType={link}
      />
    </motion.div>
  );
};

export default FormSuccessFeedback;
